import { useAuth } from '@praxis/component-auth'
import { useSafeAnalytics } from 'utils/analytics'
import { safeTgtLogger } from 'utils/safeTgtLogger'

export const useAbandonTime = (pageName: string) => {
    const { session } = useAuth()
    const { sendEvent } = useSafeAnalytics()

    const logAbandon = (timeInSeconds: number) => {
        const duration_ms = timeInSeconds * 1000
        try {
            void sendEvent({
                event: {
                    type: 'DWELL_TIME' as any,
                    value: duration_ms.toString(),
                },
                client: {
                    page_name: `Audio Player | Abandon | ${pageName}`,
                    employee_login_id: (
                        session?.userInfo?.lanId || 'unknown'
                    ).toUpperCase(),
                    version: process.env.APP_VERSION || '0.0.0',
                },
            })
        } catch (error) {
            const errorMessage =
                error instanceof Error ? error.message : 'Unknown error'
            safeTgtLogger.error(
                `Failed to log click event "${duration_ms.toString()}" for "Audio Player | Abandon | ${pageName}": ${errorMessage}`,
                {
                    error: {
                        message: errorMessage,
                        type: error instanceof Error ? error.name : 'Error',
                        stack_trace:
                            error instanceof Error && error.stack
                                ? error.stack
                                : 'No stack trace available',
                    },
                    event: {
                        action: 'analytics_click_event_failed',
                        category: 'analytics',
                        outcome: 'failure',
                    },
                    nonIndexedFields: {
                        eventName: duration_ms.toString(),
                        pageName: `Audio Player | Abandon | ${pageName}`,
                    },
                },
            )
        }
    }

    return { logAbandon }
}
